"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
// append script when component mounts, because React won't let us inline the script tag
function useScript(scriptUrl) {
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let cancel = true;
        const script = document.createElement('script');
        script.src = scriptUrl;
        script.onload = function () {
            setIsLoaded(true);
        };
        document.body.appendChild(script);
        const scriptElement = document.querySelector(`script[src="${scriptUrl}"]`);
        return () => {
            if (scriptElement) {
                document.body.removeChild(scriptElement);
            }
            cancel = false;
        };
    }, [scriptUrl]);
    return { isLoaded };
}
exports.default = useScript;
